import api from "../apis/API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";

export const getStoryList = (page, per_page, category) => {
  return api.post(`${ApiEndpointConstants.GET_STORY_LIST}`, {
    page,
    per_page,
    category_name: category,
  });
};
